'use client'
import type { FC } from 'react'
import BlogDetailPageStd from 'storefront-modules/blog/components/BlogDetailPageStd'
import { useCustomCart } from '#/src/custom/cart/useCustomCart'
import useProductRequest from '#/src/custom/products/useProductRequest'
import { DeliveryDTO, ProductLightDTO, StorefrontWidget, WidgetBlog } from 'ecosystem'
import useAppConfig from '#/src/custom/hooks/useAppConfig'
import { CustomProductListItem } from '#/src/custom/products/CustomProductListItem'

interface BlogDetailPageProps {
  deliveryOptions: DeliveryDTO[] | null
  widget: StorefrontWidget<WidgetBlog>
  relatedProducts: ProductLightDTO[]
}

const BlogDetailPage: FC<BlogDetailPageProps> = ({ widget, deliveryOptions, relatedProducts }) => {
  const appConfig = useAppConfig()
  const { handleAddToCart, cartItems } = useCustomCart()
  const { handleProductRequest } = useProductRequest()

  return (
    <BlogDetailPageStd
      config={{
        widget,
        deliveryOptions,
        relatedProducts,
        onFeaturedProductBuy: handleAddToCart,
        cartItems,
        onProductRequest: handleProductRequest,
        paths: {
          productsUrlPath: appConfig.paths.productsUrlPath
        },
        customComponents: {
          ProductListItem: CustomProductListItem
        }
      }}
    />
  )
}

export default BlogDetailPage
